import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";
import { ProductHubProvider } from "@/components/product-hub/ProductHubContext";
import { ProductHubTracker } from "@/components/product-hub/ProductHubTracker";

type ProductHubStoryblok = {
  title?: string;
  nav_label?: string;
  company?: string;
  header?: any[];
  body?: any[];
  background?: string;
  meta_title?: string;
  meta_description?: string;
  _uid: string;
  component: "product_hub";
  [k: string]: any;
};

type ProductHubProps = {
  blok: ProductHubStoryblok;
};

/**
 * Grundgeruest fuer Produkt-Reviews unter /reviews/<produkt> (Storyblok-Ordner
 * "productsReviews", Slug `reviews`).
 *
 * Bewusst so schlank wie `Page`: Header und Body nehmen dieselben Bloecke auf,
 * damit Redakteure jeden Hub frei zusammenstellen koennen. Hub-spezifisch ist
 * nur der Kontext samt Tracker (Views und jeder Klick nach aussen), ueber den
 * Tracking und Reporting den Hub zuordnen.
 * Hintergrund und Metadaten liest die Route wie bei `page` aus dem Content.
 */
const ProductHub = ({ blok }: ProductHubProps) => (
  <ProductHubProvider name={blok.title ?? ""} company={blok.company ?? ""}>
    <ProductHubTracker />
    {/* data-product-hub grenzt die Klickzaehlung auf den Hub-Inhalt ein. */}
    <article data-product-hub="" className="container max-w-7xl mx-auto" {...storyblokEditable(blok)}>
      <header>
        {blok.header?.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </header>

      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </article>
  </ProductHubProvider>
);

export default ProductHub;
